import Button from '@mui/material/Button'
import { grey } from '@mui/material/colors'

import { useAppContext } from '@/hooks'
import { ConfirmationOptions } from '@/pages/App/types'
interface ConfirmationDialogFooterProps {
	confirmationState: ConfirmationOptions | null
	handleClose: () => void
	handleSubmit: (isCanceled?: boolean) => void
	isProcessingStarted: boolean
}

export const ConfirmationDialogFooter = ({
	confirmationState,
	handleClose,
	handleSubmit,
	isProcessingStarted,
}: ConfirmationDialogFooterProps) => {
	const { t } = useAppContext()

	if (isProcessingStarted) {
		const isComplete = confirmationState?.taskState === 'FINISHED'
		const showDownloadButton = confirmationState?.showDownloadButton
		const hasError = confirmationState?.hasError

		if (hasError) {
			return (
				<Button
					variant="contained"
					color="error"
					onClick={handleClose}
					data-testid="confirmation-close-button"
				>
					{t('CLOSE')}
				</Button>
			)
		}

		if (showDownloadButton) {
			return (
				<Button
					variant="contained"
					color="success"
					disabled={!isComplete || !confirmationState?.onDownload}
					onClick={async () => {
						if (confirmationState?.onDownload) {
							await confirmationState.onDownload()
							handleClose()
						}
					}}
					data-testid="confirmation-download-button"
				>
					{t('DOWNLOAD')}
				</Button>
			)
		}

		return (
			<Button
				variant="contained"
				color="success"
				onClick={handleClose}
				disabled={!confirmationState || !isComplete}
				data-testid="confirmation-finish-button"
			>
				{t('FINISH')}
			</Button>
		)
	}

	return (
		<>
			<Button
				variant="outlined"
				sx={{
					color: grey[400],
					borderColor: grey[400],
				}}
				onClick={handleClose}
				data-testid="confirmation-cancel-button"
			>
				{t('CANCEL')}
			</Button>
			<Button
				variant="contained"
				color="success"
				onClick={() => handleSubmit()}
				data-testid="confirmation-save-button"
			>
				{t('SAVE_AND_UPDATE')}
			</Button>
		</>
	)
}
